import React, { useEffect, useRef, useState } from 'react';
import './SlidingBanner.css';

interface Banner {
  id: string;
  title: string;
  subtitle?: string;
  color: string;
  icon?: string;
  imageUrl?: string;
  textColor?: string;
  titleFontSize?: number;
  subtitleFontSize?: number;
  fontFamily?: string;
}

interface SlidingBannerProps {
  banners: Banner[];
}

const SlidingBanner: React.FC<SlidingBannerProps> = ({ banners }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollViewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [banners.length]);

  useEffect(() => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollLeft = currentIndex * scrollViewRef.current.offsetWidth;
    }
  }, [currentIndex]);

  return (
    <div className="sliding-banner-container">
      <div className="sliding-banner" ref={scrollViewRef}>
        {banners.map((banner) => (
          <div
            key={banner.id}
            className="banner-slide"
            style={{ 
              background: banner.color.includes('gradient') ? banner.color : `linear-gradient(135deg, ${banner.color} 0%, ${banner.color} 100%)`
            }}
          >
            {banner.imageUrl && (
              <img 
                src={banner.imageUrl} 
                alt="Banner" 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  opacity: 0.3
                }}
              />
            )}
            {banner.icon && <div className="banner-icons">{banner.icon}</div>}
            <div className="banner-text">
              <h2 style={{
                color: banner.textColor || '#000000',
                fontSize: banner.titleFontSize ? `${banner.titleFontSize}px` : undefined,
                fontFamily: banner.fontFamily || 'Arial'
              }}>{banner.title}</h2>
              {banner.subtitle && (
                <p 
                  className="banner-subtitle"
                  style={{
                    color: banner.textColor || '#000000',
                    fontSize: banner.subtitleFontSize ? `${banner.subtitleFontSize}px` : undefined,
                    fontFamily: banner.fontFamily || 'Arial'
                  }}
                >{banner.subtitle}</p>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="banner-dots">
        {banners.map((_, idx) => (
          <div
            key={idx}
            className={`dot ${idx === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default SlidingBanner;
